import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PromotionDetail} from '@app/core/promotion/domain/dtos/promotion-detail';
import {PopupDispatcher} from '@app/presentation/components/errors/popup.dispatcher';
import {DisplayService} from '@app/presentation/services/display.service';
import {PromotionDetailViewModel} from './promotion-detail.view-model';
import {
  HostElementScope,
  ScrollDetectorService,
  ScrollDirection
} from "@app/presentation/services/scroll-detector-service";
import {TrackEventUseCase} from "@app/core/tracking/application/track-event-use-case";
import {CatalogScrolledEvent} from "@app/core/tracking/application/events/catalog-scrolled-event";
import {ViewDidEnter, ViewWillEnter, ViewWillLeave} from "@ionic/angular";

@Component({
  selector: 'app-promotion-detail',
  templateUrl: './promotion-detail.component.html'
})
export class PromotionDetailComponent implements OnInit, OnDestroy, ViewWillEnter, ViewWillLeave {
  isMobile$ = this.displayService.isMobileDisplay$;

  promotionDetail?: PromotionDetail

  constructor(
    private viewModel: PromotionDetailViewModel,
    private popupDispatcher: PopupDispatcher,
    private displayService: DisplayService,
    private route: ActivatedRoute,
    private hostElementRef: ElementRef,
    private scrollDetectorService: ScrollDetectorService,
    private trackEventUseCase: TrackEventUseCase,
  ) {
    this.popupDispatcher.setNotifier(viewModel.notifier);
    this.viewModel.getPromotionDetailSucceed$.subscribe({
      next: promotionDetail => {
        this.promotionDetail = promotionDetail;
      }});
  }

  ngOnInit(): void {
    this.startListeningScroll();
    this.getPromotionDetail();
  }

  ionViewWillEnter() {
    this.startListeningScroll();
  }

  ngOnDestroy(): void {
    this.stopListeningScroll();
  }

  ionViewWillLeave(): void {
    this.stopListeningScroll();
  }

  private getPromotionDetail(): void {
    const id = this.route.snapshot.paramMap.get('promotionId')!;
    this.viewModel.getPromotionDetail(id);
  }

  private startListeningScroll() {
    this.scrollDetectorService.startListening({
      direction: ScrollDirection.VERTICAL,
      threshold: 200,
      hostElement: this.hostElementRef.nativeElement,
      hostElementScope: HostElementScope.BOTH,
    }, () => {
      this.trackEventUseCase.execute(new CatalogScrolledEvent())
    });
  }

  private stopListeningScroll() {
    this.scrollDetectorService.stopListening();
  }
}
